import lrz from 'lrz'
import {
  Toast
} from 'vant';

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

export function parseQueryString(url) {
  const urlObject = {}
  if (/\?/.test(url)) {
    const urlString = url.substring(url.indexOf('?') + 1)
    const urlArray = urlString.split('&')
    urlArray.map((data) => {
      const urlItem = data
      const item = urlItem.split('=')
      urlObject[item[0]] = item[1]
    })

  }
  return urlObject
}

// 解析查询字符串
export function parseEncodeURIQueryString(queryString) {
  const query = {}
  const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&')
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].split('=')
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '')
  }
  return query
}

export function getQueryString(url, key) { // url切割
  const queryObject = parseQueryString(url)
  if (Object.keys(queryObject).length > 0) {
    return queryObject[key]
  } else {
    return ''
  }
}
export function compressFileOld(file) { // 上传文件压缩
  return new Promise((resolve, reject) => {
    if (file.size / 1024 / 1024 <= 1) {
      resolve(file)
    } else {
      lrz(file, {
        width: 1000,
        quality: 0.8,
        fieldName: file.name
      }).then((rst) => {
        let fileObj = dataURLtoFile(rst.base64, file.name) // 将base64转换为文件
        resolve(fileObj)
      }).catch(err => {
        reject(file)
      })
    }
  })
}
export function compressFile(file, files) { // 上传文件压缩
  return new Promise((resolve, reject) => {
    if (file.size / 1024 / 1024 > 10) {
      files.splice(files.length - 1, 1)
      return this.$fm(`图片[${file.name}] 超过10M，请压缩后上传`)
    }
    if (file.size / 1024 / 1024 <= 1) {
      resolve(file)
    } else {
      lrz(file.raw, {
        width: 1000,
        quality: 0.8,
        fieldName: file.name
      }).then((rst) => {
        let fileObj = dataURLtoFile(rst.base64, file.name) // 将base64转换为文件
        let obj = JSON.parse(JSON.stringify(file))
        obj.raw = fileObj
        let newFile = Object.assign({}, file, obj)
        resolve(newFile)
      }).catch(err => {
        this.$fm('上传失败')
        files.splice(files.length - 1, 1)
        reject(err)
      })
    }
  })
}
export function dataURLtoFile(dataurl, filename) { // 将base64转换为文件
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, {
    type: mime
  })
}


export function getTerminalType() {
  return new Promise(resolve => {
    //获取navigator对象
    var o = navigator.userAgent,
      t = "";
    if (/\biPhone\b|\biPad\b/.test(o) && !/android/i.test(o)) {
      t = "ios";
    } else if (/android/i.test(o)) {
      t = "android";
    }
    // else if (/windows/i.test(o)) {
    //   t = "windows";
    // }
    else {
      t = "pc"
    }
    resolve(t)
  })
}
const imgType = ['image/png', 'image/jpeg']
export function judgeUploadFile(file, other = '') { //校验上传文件公用方法
  return new Promise((resolve, reject) => {
    if (Array.isArray(file)) {
      let isGoOn = true
      file.forEach(item => {
        if (imgType.includes(item.type)) {
          if (item.size / 1024 / 1024 > 10) {
            Toast.fail('上传图片不能超过10mb')
            isGoOn = false
          }
        } else if (item.type == 'application/pdf') {
          if (item.size > 5242880) {
            Toast.fail('上传文件不能超过5mb')
            isGoOn = false
          }
        } else if (other && item.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
          if (item.size > 5242880) {
            Toast.fail('上传PDF不能超过5mb')
            isGoOn = false
          }
        } else {
          Toast.fail(`只能上传图片、PDF文件${other}`);
          isGoOn = false
        }
      })
      if (isGoOn) {
        resolve()
      } else {
        reject()
      }
    } else {
      if (imgType.includes(file.type)) {
        if (file.size / 1024 / 1024 > 10) {
          Toast.fail('上传图片不能超过10mb')
          reject()
        } else {
          resolve()
        }
      } else if (file.type == 'application/pdf') {
        if (file.size > 5242880) {
          Toast.fail('上传PDF不能超过5mb')
          reject()
        } else {
          resolve()
        }
      } else if (other && file.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        if (file.size > 5242880) {
          Toast.fail('上传Word文档不能超过5mb')
          reject()
        } else {
          resolve()
        }
      } else {
        Toast.fail(`只能上传图片、PDF文件${other}`);
        reject()
      }
    }
  })
}

//阻止页面返回
import * as dd from "dingtalk-jsapi";
export function stopBackPageFun() {
  history.pushState(null, null, document.URL);
  window.addEventListener("popstate", function () {
    history.pushState(null, null, document.URL);
  });
  dd.biz.navigation.setLeft({
    control: true, //是否控制点击事件，true 控制，false 不控制， 默认false
    text: " ", //控制显示文本，空字符串表示显示默认文本
    onSuccess: function (result) {},
    onFail: function (err) {},
  });
}
export async function monitorPersistentStorage(fileName, customList) { // 更新持久化数据
  const db = await this.$store.dispatch('db/databasePage', {
    vm: this,
    dbName: 'database',
    user: true
  })
  db.set(fileName, JSON.stringify(customList))
    .write()
}
export async function getPersistentStorage(fileName, customList) { // 获取持久化数据
  const db = await this.$store.dispatch('db/databasePage', {
    vm: this,
    dbName: 'database',
    // dbName: this.$store.getters.userInfo.userName,
    user: true
  })
  let customData = db.get(fileName).value()
  if (customData) {
    const datas = JSON.parse(customData)
    for (let key in datas) {
      customList[key].isShow = datas[key].isShow
    }
  }
}
export function debounceFun(func, wait = 500, immediate = true) { // gzg防抖函数
  let timer = null
  return function (...args) {
    const ctx = this
    if (timer) clearTimeout(timer)
    if (immediate) {
      const isTimer = !timer
      timer = setTimeout(() => {
        timer = null
      }, wait)
      if (isTimer) func.apply(ctx, args)
    } else {
      timer = setTimeout(() => {
        func.apply(ctx, args)
      }, wait)
    }
  }
}

// 环境判断 / 是否微信
export function isWeixn() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}

export function base64DecodeToText(base64) {
  const binaryString = atob(base64); // 将Base64转换为二进制字符串
  const bytes = new Uint8Array(binaryString.length); // 创建一个Uint8Array来存储字节数据
  for (let i = 0; i < binaryString.length; i++) { // 将每个字符的ASCII码转换为Uint8Array的元素
      bytes[i] = binaryString.charCodeAt(i);
  }
  return new TextDecoder().decode(bytes); // 使用TextDecoder解码Uint8Array为字符串
}

// 表头内边距归0
export function tableHeaderPadding(obj, num = 0) {
  let newObj = {
    ...obj
  }
  newObj.padding = num + 'px 0'
  return newObj
}